export default __webpack_public_path__ + "static/media/jnh2.ce555e82.jpg";